module.exports = __webpack_public_path__ + "img/concreted_concreted.3b467c39.png";